import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Button } from '@follow/ui';

interface ModalRevokeAllCodesProps {
  visible: boolean;
  activeCodeCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ModalRevokeAllCodes: React.FC<ModalRevokeAllCodesProps> = ({
  visible,
  activeCodeCount,
  onCancel,
  onConfirm,
  isLoading,
}) => (
  <Transition.Root show={visible} as={Fragment}>
    <Dialog as="div" className="relative z-50" onClose={onCancel}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-neutral-30 transition-opacity" />
      </Transition.Child>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-card outline outline-1 outline-offset-[-1px] outline-neutral-10 transition-all">
              <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-red-100">
                  <ExclamationTriangleIcon className="h-5 w-5 text-red-600" />
                </div>
                <div className="flex flex-col gap-1">
                  <Dialog.Title as="h3" className="text-neutral typo-label">
                    Révoquer tous les codes ?
                  </Dialog.Title>
                  <p className="text-neutral-80 typo-small">
                    <strong>{activeCodeCount}</strong> code{activeCodeCount > 1 ? 's' : ''} actif{activeCodeCount > 1 ? 's' : ''} sera{activeCodeCount > 1 ? 'ont' : ''} révoqué{activeCodeCount > 1 ? 's' : ''}.
                  </p>
                  <p className="text-red-600 typo-small mt-1">
                    Cette action est irréversible.
                  </p>
                </div>
              </div>
              <div className="mt-6 flex justify-end gap-2">
                <Button variant="outline" size="sm" onClick={onCancel}>
                  Annuler
                </Button>
                <Button variant="destructive" size="sm" onClick={onConfirm} disabled={isLoading} loading={isLoading}>
                  {isLoading ? 'Révocation...' : 'Révoquer'}
                </Button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
);

export default ModalRevokeAllCodes;
